/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
const PENDING_SYNC_STORAGE_KEY = 'crystalRarityPendingSyncBatch';
const PENDING_SYNC_TTL_MS = 1000 * 60 * 60;

window.PXUTheme.jsCart = {
  init: function ($section) {

    // Add settings from schema to current object
    //window.PXUTheme.jsCart = $.extend(this, window.PXUTheme.getSectionData($section));

    this.$section = $section;
    this.isSyncingDraftOrder = false;
    this.isLoadingDraftOrderSummary = false;
    this.isRemovingSyncedDraftLine = false;
    this.isRollingBackSyncedBatch = false;

    $(document).on('click', '[data-cart-page-delete]', function (e) {
      e.preventDefault();
      const lineID = $(this).data('line-item-key');
      window.PXUTheme.jsCart.removeFromCart(lineID);

      return false;
    });

    // Prevent the ajax cart form from being submitted when pressing the "Enter" key
    $('#cart_form').keydown(function(e){
      if (e.keyCode == 13) {
        e.preventDefault();
        return false;
      }
    });

    $(document).on('submit', '#cart_form', function (e) {
      const context = window.PXUTheme.jsCart.getDraftOrderContext();

      if (!context) {
        return true;
      }

      e.preventDefault();

      if (this && typeof this.reportValidity === 'function' && !this.reportValidity()) {
        return false;
      }

      const $checkoutButton = $('#checkout');
      window.PXUTheme.jsCart.syncCartToDraftOrder($checkoutButton);
      return false;
    });

    $(document).on('click', '.cart__draft-order-actions [data-draft-order-remove-synced]', function (e) {
      e.preventDefault();
      window.PXUTheme.jsCart.removeSyncedDraftLineItem($(this));
      return false;
    });

    this.prepareDraftOrderActionsForRefresh();

    $(window).on('pageshow.crystalRarityDraftSync', function () {
      window.PXUTheme.jsCart.prepareDraftOrderActionsForRefresh();
      window.PXUTheme.jsCart.rollbackPendingSyncBatchIfNeeded().finally(function () {
        window.PXUTheme.jsCart.renderDraftOrderActions();
      });
    });

    this.rollbackPendingSyncBatchIfNeeded().finally(function () {
      window.PXUTheme.jsCart.renderDraftOrderActions();
    });
  },
  renderDraftOrderActions: function (message, isError) {
    const draftOrderFlow = window.CrystalRarityDraftOrder;
    const context = draftOrderFlow && draftOrderFlow.readContext ? draftOrderFlow.readContext() : null;
    const $container = $('.cart__draft-order-actions');
    const $message = $('.cart__draft-order-actions [data-draft-order-message]');
    const activeTemplate = $container.data('draft-order-active-template') || 'Your live sale order is active: *ORDER_NAME*. You can edit your cart normally. When you are ready, use checkout with my live sale order to sync these cart items and continue to checkout.';

    if (!context) {
      this.updateCartDisplayForDraftOrder(false);
      $container.hide();
      $('.additional-checkout-buttons').show();
      this.renderCombinedSubtotal(null);
      return;
    }

    this.updateCartDisplayForDraftOrder(true);
    $container.show();
    $('.additional-checkout-buttons').hide();
    const orderLabel = context.orderName || context.email || 'this customer';
    const defaultMessage = activeTemplate.replace('*ORDER_NAME*', orderLabel);
    $message.text(message || defaultMessage);
    $message.css('color', isError ? '#c00' : '#111');

    this.loadDraftOrderSummary();
  },
  updateCartDisplayForDraftOrder: function (hasDraftOrderContext) {
    const hasCartItems = $('.cart__item-list .cart__card').length > 0;

    if (hasDraftOrderContext) {
      $('.cart__empty-cart-message').addClass('is-hidden');
      $('.cart__form').removeClass('is-hidden');
      $('#cart_form').removeClass('visually-hidden');
      return;
    }

    if (!hasCartItems) {
      $('.cart__empty-cart-message').removeClass('is-hidden');
      $('.cart__form').addClass('is-hidden');
      $('#cart_form').addClass('visually-hidden');
    }
  },
  prepareDraftOrderActionsForRefresh: function () {
    const context = this.getDraftOrderContext();
    const $container = $('.cart__draft-order-actions');

    if (!context || !$container.length) {
      return;
    }

    // Hide stale draft summary while rollback/status checks run.
    $container.hide();
    this.renderDraftOrderSummary([]);
  },
  getDraftOrderContext: function () {
    const draftOrderFlow = window.CrystalRarityDraftOrder;
    const context = draftOrderFlow && draftOrderFlow.readContext ? draftOrderFlow.readContext() : null;
    return context || null;
  },
  getDraftOrderSummaryEndpoint: function (context) {
    const workerUrl = String(context && context.workerUrl || '').replace(/\/$/, '');
    const draftOrderId = encodeURIComponent(context && context.draftOrderId || '');
    if (!workerUrl || !draftOrderId) {
      return '';
    }
    return workerUrl + '/draft-orders/' + draftOrderId + '/summary';
  },
  getDraftOrderRollbackEndpoint: function (context) {
    const workerUrl = String(context && context.workerUrl || '').replace(/\/$/, '');
    const draftOrderId = encodeURIComponent(context && context.draftOrderId || '');
    if (!workerUrl || !draftOrderId) {
      return '';
    }
    return workerUrl + '/draft-orders/' + draftOrderId + '/rollback-synced-batch';
  },
  createSyncBatchId: function () {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }

    return 'sync-' + Date.now() + '-' + Math.random().toString(16).slice(2, 10);
  },
  savePendingSyncBatch: function (context, syncBatchId) {
    if (!context || !syncBatchId) {
      return;
    }

    try {
      window.localStorage.setItem(PENDING_SYNC_STORAGE_KEY, JSON.stringify({
        draftOrderId: String(context.draftOrderId || ''),
        syncBatchId: String(syncBatchId),
        savedAt: Date.now()
      }));
    } catch (_error) {}
  },
  readPendingSyncBatch: function () {
    try {
      const raw = window.localStorage.getItem(PENDING_SYNC_STORAGE_KEY);
      if (!raw) {
        return null;
      }
      return JSON.parse(raw);
    } catch (_error) {
      return null;
    }
  },
  clearPendingSyncBatch: function () {
    try {
      window.localStorage.removeItem(PENDING_SYNC_STORAGE_KEY);
    } catch (_error) {}
  },
  rollbackPendingSyncBatchIfNeeded: function () {
    const context = this.getDraftOrderContext();
    const pending = this.readPendingSyncBatch();
    const now = Date.now();

    if (!context || !pending || !pending.syncBatchId || !pending.draftOrderId) {
      return Promise.resolve();
    }

    if (String(context.draftOrderId || '') !== String(pending.draftOrderId || '')) {
      this.clearPendingSyncBatch();
      return Promise.resolve();
    }

    if (!pending.savedAt || now - Number(pending.savedAt) > PENDING_SYNC_TTL_MS) {
      this.clearPendingSyncBatch();
      return Promise.resolve();
    }

    const endpoint = this.getDraftOrderRollbackEndpoint(context);
    if (!endpoint || this.isRollingBackSyncedBatch) {
      return Promise.resolve();
    }

    this.isRollingBackSyncedBatch = true;
    let shouldClearPending = false;
    const workerSecret = context.workerSecret ? context.workerSecret : '';

    return fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Worker-Secret': workerSecret
      },
      body: JSON.stringify({
        syncBatchId: String(pending.syncBatchId)
      })
    }).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (data) {
        if (!response.ok || !data.success) {
          throw new Error(data && data.message ? data.message : 'Unable to rollback synced live sale items.');
        }
        return data;
      });
    }).then(function (data) {
      shouldClearPending = true;
      if (data.removedCount > 0) {
        window.PXUTheme.jsCart.renderDraftOrderActions('Removed previously synced items after checkout was not completed.');
      }
    }).catch(function () {
      // Keep the pending marker on transient failures so rollback can retry on next load.
      return null;
    }).finally(function () {
      window.PXUTheme.jsCart.isRollingBackSyncedBatch = false;
      if (shouldClearPending) {
        window.PXUTheme.jsCart.clearPendingSyncBatch();
      }
    });
  },
  renderDraftOrderSummary: function (lineItems) {
    const $summary = $('.cart__draft-order-actions [data-draft-order-summary]');
    const $list = $('.cart__draft-order-actions [data-draft-order-summary-list]');
    const items = Array.isArray(lineItems) ? lineItems : [];

    if (!$summary.length || !$list.length || !items.length) {
      $summary.hide();
      $list.empty();
      return;
    }

    const rows = items.map(function (item) {
      const title = String(item && item.title || 'Item');
      const quantity = Number(item && item.quantity || 0);
      const lineText = (quantity > 0 ? quantity + ' x ' : '') + title;
      const escapedText = $('<div>').text(lineText).html();

      if (item && item.isSyncedFromCart && item.uuid) {
        const escapedUuid = $('<div>').text(String(item.uuid)).html();
        return '<li class="cart__draft-order-summary-item"><span>' + escapedText + '</span><button type="button" class="cart__draft-order-remove" data-draft-order-remove-synced data-line-item-uuid="' + escapedUuid + '">Remove</button></li>';
      }

      return '<li class="cart__draft-order-summary-item"><span>' + escapedText + '</span></li>';
    });

    $list.html(rows.join(''));
    $summary.show();
  },
  formatMoneyCents: function (cents) {
    const safeCents = Number.isFinite(cents) ? Math.round(cents) : 0;
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(safeCents, $('body').data('money-format'));
    }
    return (safeCents / 100).toFixed(2);
  },
  parseAmountToCents: function (amount) {
    const value = Number(amount);
    if (!Number.isFinite(value)) {
      return 0;
    }
    return Math.round(value * 100);
  },
  getCartSubtotalCents: function () {
    const rawValue = $('.cart__subtotal[data-cart-subtotal-cents]').first().attr('data-cart-subtotal-cents');
    const value = Number(rawValue);
    return Number.isFinite(value) ? Math.round(value) : 0;
  },
  renderCombinedSubtotal: function (draftOrder) {
    const cartSubtotalCents = this.getCartSubtotalCents();
    const draftSubtotalCents = draftOrder ? this.parseAmountToCents(draftOrder.subtotalPrice || draftOrder.totalPrice) : 0;
    const combinedCents = cartSubtotalCents + draftSubtotalCents;
    const formatted = this.formatMoneyCents(combinedCents);
    const $money = $('.cart__subtotal .money').first();

    if (!$money.length) {
      return;
    }

    $money.html(formatted);

    if (window.PXUTheme.currencyConverter && typeof window.PXUTheme.currencyConverter.update === 'function') {
      window.PXUTheme.currencyConverter.update($money[0]);
    }
  },
  loadDraftOrderSummary: function (forceReload) {
    const context = this.getDraftOrderContext();
    const $container = $('.cart__draft-order-actions');
    const workerSecret = context && context.workerSecret ? context.workerSecret : '';
    const summaryEndpoint = this.getDraftOrderSummaryEndpoint(context);

    if (!context || !summaryEndpoint) {
      this.renderDraftOrderSummary([]);
      this.renderCombinedSubtotal(null);
      return Promise.resolve();
    }

    if (this.isLoadingDraftOrderSummary && !forceReload) {
      return Promise.resolve();
    }

    this.isLoadingDraftOrderSummary = true;

    return fetch(summaryEndpoint, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'X-Worker-Secret': workerSecret
      }
    }).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (data) {
        if (!response.ok || !data.success || !data.draftOrder) {
          throw new Error($container.data('draft-order-sync-error-text') || 'Unable to load draft order items.');
        }

        window.PXUTheme.jsCart.renderDraftOrderSummary(data.draftOrder.lineItems || []);
        window.PXUTheme.jsCart.renderCombinedSubtotal(data.draftOrder || null);
      });
    }).catch(function () {
      window.PXUTheme.jsCart.renderDraftOrderSummary([]);
      window.PXUTheme.jsCart.renderCombinedSubtotal(null);
    }).finally(function () {
      window.PXUTheme.jsCart.isLoadingDraftOrderSummary = false;
    });
  },
  removeSyncedDraftLineItem: function ($button) {
    const context = this.getDraftOrderContext();
    const $container = $('.cart__draft-order-actions');
    const lineItemUuid = String($button.attr('data-line-item-uuid') || '');
    const workerUrl = String(context && context.workerUrl || '').replace(/\/$/, '');
    const draftOrderId = encodeURIComponent(context && context.draftOrderId || '');
    const workerSecret = context && context.workerSecret ? context.workerSecret : '';

    if (!context || !lineItemUuid || !workerUrl || !draftOrderId || this.isRemovingSyncedDraftLine) {
      return;
    }

    this.isRemovingSyncedDraftLine = true;
    $button.attr('disabled', 'disabled');

    const endpoint = workerUrl + '/draft-orders/' + draftOrderId + '/remove-synced-line-item';

    fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Worker-Secret': workerSecret
      },
      body: JSON.stringify({
        lineItemUuid: lineItemUuid
      })
    }).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (data) {
        if (!response.ok || !data.success) {
          throw new Error(data && data.message ? data.message : 'Unable to remove item from live sale order.');
        }

        window.PXUTheme.jsCart.renderDraftOrderActions('Removed item from your live sale order.');
        return window.PXUTheme.jsCart.loadDraftOrderSummary(true);
      });
    }).catch(function (error) {
      window.PXUTheme.jsCart.renderDraftOrderActions(error.message || 'Unable to remove item from live sale order.', true);
    }).finally(function () {
      window.PXUTheme.jsCart.isRemovingSyncedDraftLine = false;
      $button.removeAttr('disabled');
    });
  },
  syncCartToDraftOrder: function ($button) {
    const draftOrderFlow = window.CrystalRarityDraftOrder;
    const $checkoutButton = $button && $button.length ? $button : $('#checkout');
    const context = this.getDraftOrderContext();
    const syncBatchId = this.createSyncBatchId();

    if (!draftOrderFlow || this.isSyncingDraftOrder) {
      return;
    }

    this.isSyncingDraftOrder = true;
    $checkoutButton.attr('disabled', 'disabled');
    const $container = $('.cart__draft-order-actions');
    const syncingText = $container.data('draft-order-syncing-text');
    this.renderDraftOrderActions(syncingText);

    draftOrderFlow.syncCartToDraftOrder({
      syncBatchId: syncBatchId,
      onComplete: function () {
        if (typeof window.PXUTheme.jsAjaxCart !== 'undefined') {
          window.PXUTheme.jsAjaxCart.updateView();
        }
      }
    }).then(function (data) {
      const invoiceUrl = data.invoiceUrl || context.invoiceUrl;

      if (!data.skippedCartSync) {
        window.PXUTheme.jsCart.savePendingSyncBatch(context, data.syncBatchId || syncBatchId);
      }

      window.location.href = invoiceUrl;
    }).catch(function (error) {
      const errorText = $container.data('draft-order-sync-error-text');
      window.PXUTheme.jsCart.renderDraftOrderActions(error.message || errorText, true);
      window.PXUTheme.jsCart.clearPendingSyncBatch();
    }).finally(function () {
      window.PXUTheme.jsCart.isSyncingDraftOrder = false;
      $checkoutButton.removeAttr('disabled');
    });
  },
  removeFromCart: function (lineID) {
    const $cartItem = window.PXUTheme.jsCart.$section.find(`[data-line-item="${lineID}"]`);

    $cartItem.css('opacity', '0.5');

    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=0&line=' + lineID,
      dataType: 'json',
      success: function (cart) {

        $cartItem.addClass('animated zoomOut')
        $cartItem.remove();

        window.PXUTheme.jsCart.updateView(cart, lineID);

        if (typeof window.PXUTheme.jsAjaxCart !== 'undefined') {
          window.PXUTheme.jsAjaxCart.updateView();
        }
      },
      error: function (XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
      }
    });
  },
  updateView: function (cart, lineID) {

    if (cart.item_count > 0) {
      $.ajax({
        dataType: "json",
        async: false,
        cache: false,
        dataType: 'html',
        url: "/cart",
        success: function (html) {

          if (lineID !== null) {

            const updatedItems = $(html).find('.cart__item-list .cart__card');
            const currentItems = $('.cart__item-list .cart__card');

            // Checks if BOGO applied and there is a change in the number of line items
            if (updatedItems.length != currentItems.length){
              const updatedCartList = $(html).find('.cart__item-list');
              // Re-append cart items
              $('.cart__item-list').replaceWith(updatedCartList);
            }

            $(currentItems).each(function(index, element){
              $(element).attr('data-line-item', (index + 1));
              $(element).find('[data-line-item-key]').attr('data-line-item-key', (index + 1));
            })

            const itemTotal = $(html).find(`[data-line-item="${lineID}"]`).find('.cart__total');
            const quantityInput = $(html).find(`[data-line-item="${lineID}"]`).find('.quantity-input');
            const itemPrice = $(html).find(`[data-line-item="${lineID}"]`).find('.cart__price');

            $(`[data-line-item="${lineID}"]`).find('.cart__total').replaceWith(itemTotal);
            $(`[data-line-item="${lineID}"]`).find('.quantity-input').replaceWith(quantityInput);
            $(`[data-line-item="${lineID}"]`).find('.cart__price').replaceWith(itemPrice);

          }

          const subtotal = $(html).find('.cart__subtotal-container');
          const discounts = $(html).find('.cart__discounts');
          const savings = $(html).find('.cart__total-savings');

          $('.cart__subtotal-container').replaceWith(subtotal);

          if (discounts.length > 0 && $('.cart__discounts').length < 1) {
            $('.cart__subtotal-container').before(discounts);
          } else {
            $('.cart__discounts').replaceWith(discounts);
          }

          if (savings.length > 0 && $('.cart__total-savings').length < 1) {
            $('.cart__subtotal-container').after(savings);
          } else {
            $('.cart__total-savings').replaceWith(savings);
          }

          $('[data-bind="itemCount"]').text(cart.item_count);

        }
      });

    } else {
      $('.cart__empty-cart-message').removeClass('is-hidden');
      $('.cart__form').addClass('is-hidden');
      $('#cart_form').addClass('visually-hidden');
      $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
      $('[data-bind="itemCount"]').text('0');
    }

    this.renderDraftOrderActions();

  },
  unload: function ($section) {
    // Clear event listeners in theme editor
    $('[data-cart-page-delete]').off();
    $('#cart_form').off();
    $(window).off('pageshow.crystalRarityDraftSync');
  }
}

/******/ })()
;
